import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";
import { ProgressContext } from "../../../components/Context/progressContext";
import { RequestNextApi } from "../../../api/Request";
import { ShowNotification } from "../../../utils/notification/snackbarUtils";
import { GlobalsContext } from "../../../components/Context/globalsContext";
import Error404 from "../../404";
import LargeFirmHome from "./components/home";
import LargeFirmLogin from "./components/login";

export default function LargeFirmSites() {

    const router = useRouter();
    const { state: progressContext, update: updateProgress } = useContext(ProgressContext);
    const [loginRequired,setLoginRequired] = useState(true);
    const [pageExist,setPageExist] = useState(true);
    const { update: updateGlobals, state: globalsContext } = useContext(GlobalsContext);




    const { pid } = router.query;

    useEffect(()=>{
        const initPage = async (pid) => {
            updateProgress({ isLoading: true });
            await firmExist(pid);
            //await fetchFirms(pid);
        };
        if(pid){
            initPage(pid);
            
        }

    },[pid]);

    const firmExist = async(pid)=>{
        try{
            const res= await RequestNextApi.post('/large-firms/firm-exist',
            {
                slug: pid,
            }
            );
            if (res.data.success) {
                if(!res.data.password_protected){
                   await fetchFirms(pid);
                }else{
                    updateProgress({ isLoading: false });
                }
                setLoginRequired(res.data.password_protected);

            } else {
                ShowNotification.error(res.data.message);
            }
        }catch (error) {
            setPageExist(false);
            ShowNotification.error('Page not found');
        }
    }


    const fetchFirms = async(pid)=>{
        try{
        const res = await RequestNextApi.post('/large-firms',
                {
                    slug: pid,
                    password:""
                }
            );
            if (res.data) {
                console.log(res.data.success);
                updateGlobals({ globals: res.data,
                    isLogin:true });
                updateProgress({ isLoading: false });
            } else {
                ShowNotification.error(res.data.message);
            }
        }catch(error){
            console.log('fetch firm error '+error);
            updateProgress({ isLoading: false });

        }
            
    }
    return (
        <>
            {pageExist? 
                loginRequired? <LargeFirmLogin></LargeFirmLogin>:<LargeFirmHome></LargeFirmHome>
            :
            <Error404></Error404>
            }
       </>

    );
    
}

LargeFirmSites.isPublic = true;
LargeFirmSites.getLayout = page => <>{page}</>;
